<template>
  <div
    :class="componentClasses"
    @click="clicked"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Chip',
  computed: {
    componentClasses: function () {
      return {
        'rc-chip': true
      }
    }
  },
  methods: {
    /**
     * function to emit the click event
     */
    clicked () {
      if (!this.disabled) {
        this.$emit('click')
      }
    }
  }
}
</script>

<style scoped></style>
